<div class="row px-0 mx-0 align-items-center" *ngFor="let question of input.MainElementList">
  <p class="col-12 px-0 mb-0 q-bold q-text-s">{{question.CloseLabel}}</p>
  <div *ngFor="let reponse of question.SelectOptionsList ; let i = index" class="col-auto q-check radio" [title]="reponse.Text">
    <input type="radio" id="{{question.ID}} + _ + {{i}} + _ + {{uuid}}"
           [value]="reponse.Value"
           [name]="question.ID"
           [checked]="reponse.Selected"
           (click)="SetResponse(question, $event.target.value)"/>
    <label for="{{question.ID}} + _ + {{i}} + _ + {{uuid}}" class="label-reponse">
      <span class="span-reponse"></span>{{reponse.Text}}
    </label>
  </div>
</div>
